

export enum MessageType {
    info,
    warn,
    error,
}
